export default __webpack_public_path__ + "1ba4f440effbf3a106ce48a7357a599d.svg";